import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from '@challenger/care/services/canonical.service';
import { ComponentHeadTagMetaTagSection } from '@challenger/care/modules/graphql/generated/graphql-types';
import { Injectable } from '@angular/core';
import { MetaTag } from '@challenger/care/models/meta-tag.enum';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  addOnMetaTags = [
    { name: 'alternate', content: 'https://www.virginmedia.com', dataType: 'en-gb' },
    { name: 'alternate', content: 'https://www.virginmedia.com', dataType: 'x-default' },
  ];
  defaultMetaTag = [{ name: 'robots', content: 'noindex' }];

  constructor(private title: Title, private meta: Meta, private canonicalService: CanonicalService) {}

  updatePageSeo(title: string, description?: string) {
    this.updatePageTitle(title);

    if (description) {
      this.updatePageDescription(description);
    }
  }

  updatePageTitle(pageTitle: string) {
    this.title.setTitle(pageTitle);
  }

  updatePageDescription(pageDescription: string) {
    this.updateMetaTag('description', pageDescription);
  }
  addMetaTag(tagName: string, tagValue: string, dataType: string = null) {
    this.meta.addTag({ name: tagName, href: tagValue, hreflang: dataType });
  }

  updateMetaTag(tagName: string, tagValue: string) {
    this.meta.updateTag({ name: tagName, content: tagValue });
  }

  updateAlternateTags(tagName: string, tagValue: string, dataTypes: string[]) {
    dataTypes.forEach((item) => {
      this.meta.updateTag({ name: tagName, href: tagValue, hreflang: item }, "hreflang='" + item + "'");
    });
  }

  updateListedMetaTags(metaTags: ComponentHeadTagMetaTagSection[], tagsToInclude: string[]) {
    this.updateMetaTags(metaTags.filter((metaTag) => tagsToInclude.includes(metaTag.name)));
  }

  updateMetaTags(metaTags: ComponentHeadTagMetaTagSection[]) {
    if (metaTags?.length) {
      metaTags = this.addAlternateMetaTags(metaTags);
      metaTags.forEach((metaTag) => {
        if (metaTag.name === MetaTag.Canonical) {
          this.canonicalService.setCanonicalURL(metaTag.content);
        } else if (metaTag.name === MetaTag.Alternate) {
          const { name, content, dataType } = metaTag;
          this.addMetaTag(name, content, dataType);
        } else {
          const { name, content } = metaTag;
          this.updateMetaTag(name, content);
        }
      });
    } else {
      const { name, content } = this.defaultMetaTag[0];
      this.updateMetaTag(name, content);
    }
  }
  addAlternateMetaTags(metaTags) {
    const alternateTagIndex = metaTags.findIndex((meta) => {
      return meta?.name === MetaTag.Alternate && meta?.dataType?.toLowerCase() === 'en-ie';
    });
    const canonical = metaTags.find((item) => {
      return item?.name === MetaTag.Canonical;
    });
    if (alternateTagIndex !== -1) {
      if (canonical) {
        this.addOnMetaTags.forEach((item, index) => {
          if (
            item?.name === MetaTag.Alternate &&
            (item?.dataType?.toLowerCase() === 'en-gb' || item?.dataType?.toLowerCase() === 'x-default')
          ) {
            this.addOnMetaTags[index].content = canonical.content;
          }
        });
        return [...metaTags, ...this.addOnMetaTags];
      } else {
        metaTags.splice(alternateTagIndex, 1);
        return metaTags;
      }
    } else {
      return metaTags;
    }
  }
}
